function fiscatAeeDayOpenV8(type1 = 'LOCA', type1Amount = 0, type2 = 'CY01', type2Amount = 0, type2Rate = '') {
  let code = `http://www.fiscat.com/AEE|OP|${type1}||${type1Amount}`
  if (type2Amount > 0) {
    code += `|${type2}||${type2Amount}||${type2Rate}`
  }
  return { code }
}

function fiscatAeeDayCloseV8(dept = 1, plu = 1, exchange = 0, x = 1) {
  let code = `http://www.fiscat.com/AEE|DC|${dept || ''}|${plu || ''}|${exchange || ''}|${x || ''}`
  return { code }
}

// http://www.fiscat.com/AEE|SLD|1||||||2|Gyujto2|2|91|1|Gyujto6|6|9|1|P

const fiscatAeePaymentAgent = {
  'cash': 'P',
  'bankCard': 'N',
  'online': 'N',
  'voucher': 'O3',
  'other': 'O8',
  'cashEuro': 'F',
  'szepkartya': 'O2',
  'transfer': 'N',
  'credit': 'O8',
  'vip': 'O4',
}

function fiscatSaleItemsTax(items, payments, footer = []) {
  if (items?.length === 0) return []
  let prefix = `http://www.fiscat.com/AEE|SLT|||${footer?.length > 0 ? footer.length + footer.map(line => `|${line}`) : ''}||||`
  let codes = []
  let code = prefix + items.length
  for (let item of items) {
    let itemCode = `|${(item.name || 'Termék').slice(0, 18)}|${item.vatLetter}${(item.vatRegister + '').padStart(2, '0')}|${+item.discountPrice > 0 ? +item.discountPrice : '0'}|${item.count}|`
    code += itemCode
  }
  for (let payment of payments) {
    let paymentCode = `|${fiscatAeePaymentAgent[payment.agentType] || 'N'}|${payment?.amount || ''}`
    code += paymentCode
  }
  if (code.length > 0) {
    codes.push(code)
  }
  return codes
}

function fiscatSaleItemsDept(items, payments, footer = []) {
  if (items?.length === 0) return []
  let prefix = `http://www.fiscat.com/AEE|SLD|||${footer?.length > 0 ? footer.length + footer.map(line => `|${line}`) : ''}||||`
  let codes = []
  let code = prefix + items.length
  for (let item of items) {
    let itemCode = `|${(item.name || 'Termék').slice(0, 18)}|${item.vatRegister}|${+item.discountPrice}|${item.count}|`
    code += itemCode
  }
  for (let payment of payments) {
    let paymentCode = `|${fiscatAeePaymentAgent[payment.agentType] || 'N'}|${payment?.amount || ''}`
    code += paymentCode
  }
  if (code.length > 0) {
    codes.push(code)
  }
  return codes
}

function fiscatAeeSaleV8(fiscalReceipt, options = {}) {
  if (!fiscalReceipt) return { success: false, message: 'No order or payment' }
  let { printByRegister = false, printByTax = false } = options || {}
  let res = {}
  res.paymentsTotal = fiscalReceipt.paymentsTotal
  if (!printByRegister && fiscalReceipt.items?.length < 50) {
    if (!printByTax) {
      res.codes = fiscatSaleItemsDept(fiscalReceipt.items, fiscalReceipt.payments, fiscalReceipt.footer)
    } else {
      res.codes = fiscatSaleItemsTax(fiscalReceipt.items, fiscalReceipt.payments, fiscalReceipt.footer)
    }
  } else {
    let code = `http://www.fiscat.com/AEE|SLD|||||||${Object.entries(fiscalReceipt.vatRegisterSums || {}).length}`
    for (let [vatRegister, price] of Object.entries(fiscalReceipt.vatRegisterSums)) {
      code += `|GY${vatRegister}|${vatRegister}|${price}|1|`
    }
    for (let payment of fiscalReceipt.payments) {
      code += `|${fiscatAeePaymentAgent[payment.agentType] || 'N'}|${payment?.amount || ''}`
    }
    res.codes = [code]
  }
  return res
}

// 1 – ügyfél elállása (customer wants)
// 2 – kezelői hiba: téves bevitel (operator mistake)
// 3 – kezelői hiba: téves fizetőeszköz bevitel  (operator mistake, wrong payment type chosen)
// 4 – kezelői hiba: termék nincs készleten  (operator mistake, item not on stock)
// 5 – technikai: téves bizonylattípus kibocsátása (technical mistake, wrong receipt type)
// 6 – technikai: sikertelen fizetőeszköz használat  (technical mistak, unsuccessful payment type used)
// 7 – technikai: téves ügyfél adat/hibás bevitel (technical mistake, wrong user data)
// 8 – technikai: próbavásárlás (technical, practice sales only)
// 0 – egyéb  (other)

function fiscatAeeStornoV8(fiscalReceipt) {
  let {
    zCount = '',
    reasonID = 0,
    receiptNumber,
    taxNumber = '',
    name = '',
    zipCode = '',
    city = '',
    address = '',
    street = '',
    streetNumber = '',
  } = fiscalReceipt || {}
  let code = `http://www.fiscat.com/AEE|STORNO|${zCount}|${receiptNumber || ''}|${reasonID || ''}|${taxNumber}|${name}|${zipCode}|${city}|${address}|${street}|${streetNumber}`
  //console.log({code})
  return { code }
}

// 01 - váltópénz bevitel  (enter change)
// 02 - pénztáros pénzfelvétel
// 03 - díjbeszedés (fee collection)
// 04 - sorsjegy eladás (lottery ticket sales)
// 05 - előleg (deposit)
// 06 - pénztárhiány (cash shortage)
// 07 - borravaló  (tip)
// 08 - egyéb befizetés  (other)

function fiscatAeePayInV8(reasonCode, paymentAmount, paymentType = 'cash', info) {
  //if(paymentType !== 'cash') return { code: null} 
  let { checkID = '', rate = '', notes = [] } = info || {}
  let code = `http://www.fiscat.com/AEE|RA|${(+reasonCode).toString().padStart(2, '0')}|${checkID || ''}|2|${notes?.length}|${notes?.length > 0 ? notes?.join('|') + '|' : ''}LOCA|${paymentAmount}|${rate || ''}`
  //fiscat/AEE|RA|07||1|1|HELLO|LOCA|125|
  return { code }
}

// 31 - fölözés (skim)
// 32 - pénztáros levétel (pay out to cashier)
// 33 - utalvány kivét (pay out cheq)
// 34 - ajándékkártya kivét (gift card pay out)
// 35 - bérkifizetés (sallary pay out)
// 36 - munkabér előleg (salles deposit)
// 37 - postaköltség (post cost)
// 38 - egyéb rezsi (other fee)
// 39 - áruvásárlás (buy goods)
// 40 - záróösszeg levétel (total pay out)
// 41 - egyéb kifizetés (other pay out)

function fiscatAeePayOutV8(reasonCode, paymentAmount, paymentType = 'cash', info) {
  //if(paymentType !== 'cash') return { code: null}
  let { checkID = '', rate = '', notes = [] } = info || {}
  let code = `http://www.fiscat.com/AEE|PO|${(+reasonCode + 30).toString()}|${checkID || ''}|2|${notes?.length}|${notes?.length > 0 ? notes?.join('|') + '|' : ''}LOCA|${paymentAmount}|${rate || ''}`
  return { code }
}

export {
  fiscatAeeSaleV8,
  fiscatAeeDayOpenV8,
  fiscatAeeDayCloseV8,
  fiscatAeeStornoV8,
  fiscatAeePayInV8,
  fiscatAeePayOutV8
}
